import {
    AnyAction,
    CaseReducer,
    prepareAutoBatched,
} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'
import {NinchatUserUpdatedEvent} from '../types/events'
import {extractProperties} from './'

type UserUpdatedPreparedEventAction = {
    prepare: (payload: AnyAction) => {meta: unknown, payload: AnyAction}
    reducer: CaseReducer<NinchatState>
}

export const userUpdated: UserUpdatedPreparedEventAction = {
    prepare: prepareAutoBatched<AnyAction>(),
    reducer: (state, action) => {
        const {
            user_id,
            ...properties
        } = extractProperties<NinchatUserUpdatedEvent>(action.payload)

        if (user_id === state.user_id) {
            return {
                ...state,
                ...properties,
            }
        }

        return {
            ...state,
            _users: {
                ...state._users,
                [user_id]: {
                    ...state._users[user_id],
                    ...properties,
                },
            },
        }
    },
}
